import React, { useEffect, useState } from "react";
import CustomInput from "../../../components/CustomInput";
import { useForm } from "react-hook-form";
import { dashboard_invoice_approve } from "../../../assets/images";
//import "./orderedit.css";
import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { ServiceData, ServiceType } from "../../../types";
import AuthRules from "../../../rules/AuthRules";
import rules from "../../../rules";
import AFLSuccessModal from "../../../components/AFL/AFLSuccessModal";
import AFLErrorModal from "../../../components/AFL/AFLErrorModal";

interface LocationData {
  [x: string]: any;
  latitude: number;
  longitude: number;
}

interface RecollectionLocationData {
  Recollectionlatitude: number;
  Recollectionlongitude: number;
}

const ServiceCreation = () => {
  const location = useLocation();

  //----------------------------
  const [selectedService, setSelectedService] = useState("");
  const [selectedServiceType, setSelectedServiceType] = useState("");

  const [selectedPlateNum, setSelectedPlateNum] = useState("");
  const [selectedMake, setSelectedMake] = useState<string>("");
  const [selectedModel, setSelectedModel] = useState<string>("");
  const [isOtherMakeSelected, setIsOtherMakeSelected] = useState(false);
  const [customMake, setCustomMake] = useState("");
  const [customModel, setCustomModel] = useState<string>("");
  const [comments, setComments] = useState("");

  //--------------------------------

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionClicked, setSuggestionClicked] = useState(false);
  const [addressSuggestions, setAddressSuggestions] = useState<string[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<LocationData>({
    latitude: 0,
    longitude: 0,
  });
  const [selectedRecollectionLocation, setSelectedRecollectionLocation] =
    useState<RecollectionLocationData>({
      Recollectionlatitude: 0,
      Recollectionlongitude: 0,
    });

  const [recollectionSearchQuery, setRecollectionSearchQuery] =
    useState<string>("");
  const [recollectionAddressSuggestions, setRecollectionAddressSuggestions] =
    useState<string[]>([]);
  const [recollectionSuggestionClicked, setRecollectionSuggestionClicked] =
    useState(false);

  // const [isChecked, setIsChecked] = useState(true);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [RefNumber, setRefNumber] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  // const [toLocations, setToLocations] = useState<string[]>([]);
  //const [fromLocations, setFromLocations] = useState<string[]>([]);

  //const [selectedToLocation, setSelectedToLocation] = useState("");
  ///const [selectedFromLocation, setSelectedFromLocation] = useState("");

  //-----------------------------
  const [toLocations, setToLocations] = useState<
    { location: string; latitude: number | null; longitude: number | null }[]
  >([]);
  const [fromLocations, setFromLocations] = useState<
    { location: string; latitude: number | null; longitude: number | null }[]
  >([]);

  const [selectedToLocation, setSelectedToLocation] = useState("");
  const [selectedFromLocation, setSelectedFromLocation] = useState("");
  const [locationInputType, setLocationInputType] = useState<
    "dropdown" | "search"
  >("dropdown");
  const [toLocationInputType, setToLocationInputType] = useState<
    "dropdown" | "search"
  >("dropdown");

  const [selectedToLatLon, setSelectedToLatLon] = useState<{
    latitude: number | null;
    longitude: number | null;
  } | null>(null);

  const [selectedFromLatLon, setSelectedFromLatLon] = useState<{
    latitude: number | null;
    longitude: number | null;
  } | null>(null);

  //----------------------------------
  const navigate = useNavigate();

  const {
    control,
    setValue,
    getValues,
    formState: { isValid },
  } = useForm({ mode: "onChange" });

  //----------------------------------------

  const { data: serviceType } = useQuery<ServiceType[], Error>({
    queryKey: ["serviceType"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.SERVICE_TYPES);
      return response.data;
    },
  });

  const handleServiceTypeChange = (event: any) => {
    const selectedValue = event.target.value;
    const selectedServiceData = serviceType?.find(
      (type) => type?.serviceName === selectedValue
    );

    if (selectedServiceData) {
      // Reset all location related states
      setToLocations([]);
      setFromLocations([]);
      setSelectedService(selectedServiceData.serviceName);
      setSelectedServiceType(selectedServiceData.serviceType);
      setShowOtherLocation(false);
      setOtherLatitude("");
      setOtherLongitude("");
      setSelectedToLocation("");
      setSelectedFromLocation("");
      setSelectedToLatLon(null);
      setSelectedFromLatLon(null);
      setSelectedLocation({
        latitude: 0,
        longitude: 0,
      });
      setSelectedRecollectionLocation({
        Recollectionlatitude: 0,
        Recollectionlongitude: 0,
      });
      setSearchQuery("");
      setRecollectionSearchQuery("");
      setAddressSuggestions([]);
      setRecollectionAddressSuggestions([]);
      setLocationInputType("dropdown");
      setToLocationInputType("dropdown");

      // Reset form fields
      setValue("Location", "");
      setValue("RecollectionLocation", "");

      // Pass 'OTHERS' as vehicle_type if 'Others' is selected for make
      handleGetLocationType.mutate({
        vehicle_type: isOtherMakeSelected ? "OTHERS" : selectedMake,
      });
    }
  };

  //---------------------------------------------

  const { data: emiratesCode } = useQuery<any[], Error>({
    queryKey: ["emiratesCode"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.EMIRATES_CODE);
      return response.data;
    },
  });

  const handlePlateNumChange = (event: any) => {
    const selectedPlatenumValue = event.target.value;
    setSelectedPlateNum(selectedPlatenumValue);
  };

  //------------------------------------------------

  //------------------------------------

  const {
    data: makeModelList,
    isLoading,
    error,
  } = useQuery<Record<string, string[]>, Error>({
    queryKey: ["makeModelList"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.MAKE_MODEL_LIST);
      return response.data;
    },
  });

  const handleMakeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setToLocations([]);
    setFromLocations([]);
    setSelectedToLocation("");
    setSelectedFromLocation("");
    setSelectedToLatLon(null);
    setSelectedFromLatLon(null);
    setSelectedService("");
    setSelectedServiceType("");

    if (selectedValue === "Others") {
      setIsOtherMakeSelected(true);
      setSelectedMake("");
      setSelectedModel("");
      handleGetLocationType.mutate({ vehicle_type: "OTHERS" });
      handleServiceTypeChange({ target: { value: selectedService } });
    } else {
      setIsOtherMakeSelected(false);
      setSelectedMake(selectedValue);
      setSelectedModel("");
      handleGetLocationType.mutate({ vehicle_type: selectedValue });
      handleServiceTypeChange({ target: { value: selectedService } });
    }
  };
  const [scheduleType, setScheduleType] = useState<string>("schedule_now");

  const handleScheduleTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setScheduleType(event.target.value);
  };

  const handleCustomMakeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCustomMake(event.target.value);
  };

  const handleModelChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedModel(event.target.value);
    setToLocations([]);
    setFromLocations([]);
    setSelectedToLocation("");
    setSelectedFromLocation("");
    setSelectedToLatLon(null);
    setSelectedFromLatLon(null);
    setSelectedService("");
    setSelectedServiceType("");
  };
  const handleCustomModelChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCustomModel(event.target.value);
  };

  const handleCommentsChange = (event: any) => {
    setComments(event.target.value);
  };

  //------------------------------------
  // const [dateTime, setDateTime] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");
  const [timeError, setTimeError] = useState("");

  const validateDateTime = (dateTimeStr: string) => {
    if (!dateTimeStr) return false;

    const selected = new Date(dateTimeStr);
    const now = new Date();
    const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

    return selected >= twoHoursLater;
  };

  useEffect(() => {
    const now = new Date();
    const localNow = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
    const isoString = localNow.toISOString().substring(0, 16);
    setMinDateTime(isoString);

    if (scheduleType === "schedule_for") {
      // Set to 2 hours and 1 minute from now
      localNow.setHours(localNow.getHours() + 2);
      localNow.setMinutes(localNow.getMinutes() + 1);
      const newDateTime = localNow.toISOString().substring(0, 16);
      setDateTime(newDateTime);
      setTimeError("");
    } else if (scheduleType === "schedule_now") {
      setDateTime(isoString);
      setTimeError("");
    }
  }, [scheduleType]);

  const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDateTime = event.target.value;
    setDateTime(newDateTime);

    if (scheduleType === "schedule_for") {
      if (!validateDateTime(newDateTime)) {
        setTimeError("Please select a time at least 2 hours from now");
      } else {
        setTimeError("");
      }
    }
  };

  //--------------------------------------------------------

  //-------------------------------------------

  const handleInputChange = (value: string) => {
    setSearchQuery(value);
    setSuggestionClicked(false);
    // Reset location coordinates when user starts typing
    setSelectedLocation({
      latitude: 0,
      longitude: 0,
    });
  };

  const fetchLocationName = async (searchQuery: string) => {
    if (!searchQuery || searchQuery.trim() === "") {
      setAddressSuggestions([]);
      return "";
    }

    const response = await axiosInstance.get(
      `${API_URL.GET_GOOGLELOCATIONS}?keyword=${searchQuery}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const data = response.data;
    const suggestions = data.map((item: any) => item.formatted_address);
    setAddressSuggestions(suggestions);
    const locationName = data[0]?.formatted_address;
    return locationName;
  };

  const { data: locationName } = useQuery<string>({
    queryKey: ["locationName", searchQuery],
    queryFn: () => fetchLocationName(searchQuery),
    enabled: !!searchQuery && searchQuery.trim() !== "",
  });
  const handleSuggestionClick = async (selectedSuggestion: string) => {
    const response = await axiosInstance.get(
      `${API_URL.GET_GOOGLELOCATIONS}?keyword=${selectedSuggestion}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const data = response.data;
    if (data.length > 0) {
      const { lat, lng } = data[0].geometry.location;
      setSelectedLocation({
        latitude: parseFloat(lat),
        longitude: parseFloat(lng),
      });
    }
    setValue("Location", selectedSuggestion);
    setAddressSuggestions([]);
    setSuggestionClicked(true);
  };

  //--------------------------------------------------------------------
  //===========================================================================

  const handleRecollectionInputChange = (value: string) => {
    setRecollectionSearchQuery(value);
    setRecollectionSuggestionClicked(false);
    // Reset recollection location coordinates when user starts typing
    setSelectedRecollectionLocation({
      Recollectionlatitude: 0,
      Recollectionlongitude: 0,
    });
  };

  const fetchRecollectionLocationName = async (
    recollectionSearchQuery: string
  ) => {
    if (!recollectionSearchQuery || recollectionSearchQuery.trim() === "") {
      setRecollectionAddressSuggestions([]);
      return "";
    }

    const response = await axiosInstance.get(
      `${API_URL.GET_GOOGLELOCATIONS}?keyword=${recollectionSearchQuery}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const data = response.data;
    const suggestions = data.map((item: any) => item.formatted_address);
    setRecollectionAddressSuggestions(suggestions);
    return data[0]?.formatted_address;
  };

  const { data: recollectionLocationName } = useQuery<string>({
    queryKey: ["recollectionLocationName", recollectionSearchQuery],
    queryFn: () => fetchRecollectionLocationName(recollectionSearchQuery),
    enabled: !!recollectionSearchQuery && recollectionSearchQuery.trim() !== "",
  });

  const handleRecollectionSuggestionClick = async (
    selectedRecollectionSuggestion: string
  ) => {
    const response = await axiosInstance.get(
      `${API_URL.GET_GOOGLELOCATIONS}?keyword=${selectedRecollectionSuggestion}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const data = response.data;
    if (data.length > 0) {
      const { lat, lng } = data[0].geometry.location;
      setSelectedRecollectionLocation({
        Recollectionlatitude: parseFloat(lat),
        Recollectionlongitude: parseFloat(lng),
      });
    }
    setValue("RecollectionLocation", selectedRecollectionSuggestion);
    setRecollectionAddressSuggestions([]);
    setRecollectionSuggestionClicked(true);
  };

  //===========================================================================

  //------------------------------------------------------------------------------
  const accessToken = localStorage.getItem("access_token");

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };
  const decodedToken = decodeToken(accessToken);

  const merchantId =
    decodedToken && decodedToken["merchant-id"]
      ? decodedToken["merchant-id"]
      : null;

  const fetchLocationNameFromCoords = async (lat: string, lon: string) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&accept-language=en`
      );
      const data = await response.json();
      return data.display_name;
    } catch (error) {
      console.error("Error fetching location name:", error);
      return "";
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdate = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const formData = getValues();
    const recollectionLatitude =
      selectedRecollectionLocation?.Recollectionlatitude;
    const recollectionLongitude =
      selectedRecollectionLocation?.Recollectionlongitude;

    // Helper function to format date to YYYY-MM-DDTHH:mm format
    const formatDateTime = (date: Date) => {
      const pad = (num: number) => num.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };

    // Get current local time or parse the selected dateTime
    const now = new Date();
    const currentDateTime = formatDateTime(now);
    const selectedDateTime = dateTime
      ? formatDateTime(new Date(dateTime))
      : currentDateTime;

    // Use current time if 'Schedule Now' is selected, otherwise use the selected date/time
    const scheduledFor =
      scheduleType === "schedule_now" ? currentDateTime : selectedDateTime;

    const userData: ServiceData = {
      reference_number: formData?.RefNumber,
      vehicle_make: selectedMake || customMake,
      vehicle_model: selectedModel || customModel,
      plate_number: formData?.RegNumber,
      chassis_number: formData?.ChassisNumber,
      reg_number: "",
      person_name: formData?.PersonName || "",
      mobile_number: formData?.phoneNo || "",
      service_name: selectedService || "",
      service_based: selectedServiceType || "",
      scheduled_for: scheduledFor, // Always set a value
      is_scheduled_now: scheduleType === "schedule_now",
      afl_comments: comments || "",
      emirate: selectedPlateNum || "",

      ...(selectedServiceType !== "LOCATION_BASED" && {
        location_from: {
          address:
            selectedFromLocation === "Other"
              ? ""
              : selectedService === "CUSTOMER DROP"
              ? selectedFromLocation
              : selectedService === "INTERNAL MOVEMENTS"
              ? locationInputType === "dropdown"
                ? selectedFromLocation
                : selectedLocation?.address || getValues("Location")
              : getValues("RecollectionLocation") || selectedFromLocation,
          city: "",
          street: "",
          district: "",
          state: "",
          country: "",
          pinCode: "",
          latitude:
            selectedFromLocation === "Other"
              ? ""
              : selectedService === "CUSTOMER DROP"
              ? selectedFromLatLon?.latitude
              : selectedService === "INTERNAL MOVEMENTS"
              ? locationInputType === "dropdown"
                ? selectedFromLatLon?.latitude
                : selectedLocation?.latitude?.toString()
              : recollectionLatitude !== 0
              ? recollectionLatitude?.toString() || selectedToLatLon?.latitude
              : showOtherLocation
              ? otherLatitude
              : selectedToLatLon?.latitude,
          longitude:
            selectedFromLocation === "Other"
              ? ""
              : selectedService === "CUSTOMER DROP"
              ? selectedFromLatLon?.longitude
              : selectedService === "INTERNAL MOVEMENTS"
              ? locationInputType === "dropdown"
                ? selectedFromLatLon?.longitude
                : selectedLocation?.longitude?.toString()
              : recollectionLongitude !== 0
              ? recollectionLongitude?.toString() || selectedToLatLon?.longitude
              : showOtherLocation
              ? otherLongitude
              : selectedToLatLon?.longitude,
          landMark: "",
        },
      }),

      location_to: {
        address:
          selectedToLocation === "Other"
            ? ""
            : getValues("RecollectionLocation") || selectedToLocation,
        city: "",
        type: "",
        street: "",
        district: "",
        state: "",
        country: "",
        pinCode: "",
        latitude:
          selectedToLocation === "Other"
            ? ""
            : selectedService === "INTERNAL MOVEMENTS" &&
              toLocationInputType === "search"
            ? selectedRecollectionLocation?.Recollectionlatitude?.toString()
            : recollectionLatitude !== 0
            ? recollectionLatitude?.toString() || selectedToLatLon?.latitude
            : showOtherLocation
            ? otherLatitude
            : selectedToLatLon?.latitude,
        longitude:
          selectedToLocation === "Other"
            ? ""
            : selectedService === "INTERNAL MOVEMENTS" &&
              toLocationInputType === "search"
            ? selectedRecollectionLocation?.Recollectionlongitude?.toString()
            : recollectionLongitude !== 0
            ? recollectionLongitude?.toString() || selectedToLatLon?.longitude
            : showOtherLocation
            ? otherLongitude
            : selectedToLatLon?.longitude,
        landMark: "",
      },

      // These fields are already set in the main object
      // Remove duplicates to fix lint warnings
    };

    if (
      selectedService !== "INTERNAL MOVEMENTS" &&
      ((selectedLocation &&
        (selectedLocation.latitude || selectedLocation.longitude)) ||
        selectedToLocation)
    ) {
      userData.location_from = {
        address: getValues("Location") || selectedFromLocation,
        city: "",
        street: "",
        district: "",
        state: "",
        country: "",
        pinCode: "",
        latitude:
          selectedService === "CUSTOMER DROP"
            ? otherLatitude
            : selectedService === "INTERNAL MOVEMENTS" &&
              locationInputType === "dropdown"
            ? selectedFromLatLon?.latitude
            : selectedLocation?.latitude !== 0
            ? selectedLocation?.latitude?.toString() ||
              selectedFromLatLon?.latitude
            : selectedFromLatLon?.latitude,
        longitude:
          selectedService === "CUSTOMER DROP"
            ? otherLongitude
            : selectedService === "INTERNAL MOVEMENTS" &&
              locationInputType === "dropdown"
            ? selectedFromLatLon?.longitude
            : selectedLocation?.longitude !== 0
            ? selectedLocation?.longitude?.toString() ||
              selectedFromLatLon?.longitude
            : selectedFromLatLon?.longitude,
        // latitude: selectedLocation.latitude?.toString() || selectedFromLatLon?.latitude,
        //longitude: selectedLocation.longitude?.toString() || selectedFromLatLon?.latitude,
        landMark: "",
      };
    }
    handleServiceCreation.mutate(userData);
  };

  const handleServiceCreation = useMutation({
    mutationFn: (userData: ServiceData) =>
      axiosInstance.post(`${API_URL.CREATE_SERVICE}`, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    onSuccess: (successResponse) => {
      if (successResponse.status && successResponse?.data) {
        setRefNumber(successResponse.data.reference_number || ""); // Store ERP order number
        setShowSuccessModal(true);
      }
      setIsSubmitting(false);
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      }
      setIsSubmitting(false);
    },
  });

  const handleGetLocationType = useMutation({
    mutationFn: async (userData: { vehicle_type: string }) =>
      axiosInstance.post(`${API_URL.GET_LOCATIONS}`, userData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    onSuccess: (successResponse) => {
      const locations = successResponse?.data;

      if (locations?.length > 0) {
        setToLocations(
          locations
            .filter((item: any) => item.toLocation) // Ensure non-null values
            .map((item: any) => ({
              location: item.toLocation,
              latitude: item.latitude,
              longitude: item.longitude,
            }))
        );

        setFromLocations(
          locations
            .filter((item: any) => item.toLocation) // Ensure non-null values
            .map((item: any) => ({
              location: item.toLocation,
              latitude: item.latitude,
              longitude: item.longitude,
            }))
        );
      }
    },
    onError: (error: any) => {
      console.error("Error fetching locations:", error);
    },
  });

  const [showOtherLocation, setShowOtherLocation] = useState(false);
  const [otherLatitude, setOtherLatitude] = useState<string>("");
  const [otherLongitude, setOtherLongitude] = useState<string>("");

  const handleToLocationChange = (selectedLocation: string) => {
    setSelectedToLocation(selectedLocation);

    if (selectedLocation === "Other") {
      setShowOtherLocation(true);
      setSelectedToLatLon(null);
    } else {
      setShowOtherLocation(false);
      // Find the corresponding lat/lon
      const locationData = toLocations.find(
        (loc) => loc.location === selectedLocation
      );

      if (locationData) {
        setSelectedToLatLon({
          latitude: locationData.latitude,
          longitude: locationData.longitude,
        });
      } else {
        setSelectedToLatLon(null);
      }
    }
  };

  const handleOtherLatitudeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newLat = e.target.value;
    setOtherLatitude(newLat);

    // Only fetch location name if both lat and lon are present
    if (newLat && otherLongitude) {
      fetchLocationNameFromCoords(newLat, otherLongitude).then(
        (locationName) => {
          setSelectedToLocation(locationName);
        }
      );
    }

    setSelectedToLatLon({
      latitude: Number(newLat),
      longitude: selectedToLatLon?.longitude || null,
    });
  };

  const handleOtherLongitudeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newLon = e.target.value;
    setOtherLongitude(newLon);
    // Only fetch location name if both lat and lon are present
    if (otherLatitude && newLon) {
      fetchLocationNameFromCoords(otherLatitude, newLon).then(
        (locationName) => {
          setSelectedToLocation(locationName);
        }
      );
    }

    setSelectedToLatLon({
      latitude: selectedToLatLon?.latitude || null,
      longitude: Number(newLon),
    });
  };

  const handleFromLocationChange = (selectedLocation: string) => {
    setSelectedFromLocation(selectedLocation);

    if (selectedLocation === "Other") {
      setShowOtherLocation(true);
      setSelectedFromLatLon(null);
    } else {
      setShowOtherLocation(false);
      // Find the corresponding lat/lon
      const locationData = toLocations.find(
        (loc) => loc.location === selectedLocation
      );

      if (locationData) {
        setSelectedFromLatLon({
          latitude: locationData.latitude,
          longitude: locationData.longitude,
        });
      } else {
        setSelectedFromLatLon(null);
      }
    }
    // Find the corresponding lat/lon
    const locationData = fromLocations.find(
      (loc) => loc.location === selectedLocation
    );

    if (locationData) {
      setSelectedFromLatLon({
        latitude: locationData.latitude,
        longitude: locationData.longitude,
      });
    } else {
      setSelectedFromLatLon(null);
    }
  };

  //=====================================================

  const isButtonDisabled = (): boolean => {
    if (!isValid) {
      return true;
    }

    const isMakeValid = !!(customMake.trim() || selectedMake);
    const isModelValid = !!(customModel.trim() || selectedModel);
    const isTimeValid =
      scheduleType !== "schedule_for" || validateDateTime(dateTime);

    const isLocationBasedValid =
      selectedToLocation === "Other" ||
      !!(
        (selectedRecollectionLocation?.Recollectionlatitude &&
          selectedRecollectionLocation?.Recollectionlongitude) ||
        (selectedToLatLon?.latitude && selectedToLatLon?.longitude)
      );

    const isDistanceBasedValid =
      selectedFromLocation === "Other" ||
      !!(
        (selectedRecollectionLocation?.Recollectionlatitude &&
          selectedRecollectionLocation?.Recollectionlongitude) ||
        (selectedLocation.latitude && selectedLocation.longitude) ||
        (selectedFromLatLon?.latitude && selectedFromLatLon?.longitude)
      );

    if (selectedServiceType === "LOCATION_BASED") {
      return !(
        (isLocationBasedValid || selectedToLocation === "Other") &&
        isMakeValid &&
        isModelValid &&
        selectedService &&
        selectedServiceType &&
        scheduleType &&
        isTimeValid
      );
    }
    if (selectedServiceType === "DISTANCE_BASED") {
      return !(
        (isDistanceBasedValid || selectedFromLocation === "Other") &&
        (isLocationBasedValid || selectedToLocation === "Other") &&
        isMakeValid &&
        isModelValid &&
        selectedService &&
        selectedServiceType &&
        scheduleType &&
        isTimeValid
      );
    }
    return true;
  };
  //-------------------------------------------------------------------------

  return (
    <div className="row afl-custom">
      <div className="col-md-12 text-start div-bg-invoice-details">
        <div className="card card-bg-invoice-details">
          <div className="card-body px-5">
            <table className="table table-bordered align-middle">
              <tbody>
                {/* Ref No */}
                <tr>
                  <td className="w-25">
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Job Reference No:<span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    <CustomInput
                      inputName="RefNumber"
                      inputType="text"
                      className="merchant-input-style-create-product creationWidth"
                      placeholder=""
                      editable={true}
                      onInputChange={(value: string) => {}}
                      control={control}
                      rules={rules.AuthRules.productDescription}
                    />
                  </td>
                </tr>

                {/* Make */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Vehicle Make
                      <span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    {!isOtherMakeSelected ? (
                      <select
                        className="select-invoice-bg-black-edit dashboard-poppins-font-style creationWidth"
                        onChange={handleMakeChange}
                        value={selectedMake}
                      >
                        <option value="" key="select-make">
                          Select
                        </option>
                        {makeModelList &&
                          Object.keys(makeModelList).map((make) => (
                            <option value={make} key={make}>
                              {make}
                            </option>
                          ))}
                        <option value="Others" key="others">
                          Others
                        </option>
                      </select>
                    ) : (
                      <div className="position-relative creationWidth d-flex">
                        <input
                          type="text"
                          className="form-control "
                          placeholder="Enter Make"
                          value={customMake}
                          onChange={handleCustomMakeChange}
                        />
                        <button
                          type="button"
                          className="btn"
                          onClick={() => {
                            setIsOtherMakeSelected(false);
                            setCustomMake("");
                            setCustomModel("");
                            setSelectedMake("");
                          }}
                          style={{
                            border: "none",
                            background: "transparent",
                            color: "red",
                          }}
                        >
                          x
                        </button>
                      </div>
                    )}
                  </td>
                </tr>

                {/* Model */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Vehicle Model
                      <span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    {!isOtherMakeSelected ? (
                      <select
                        className="select-invoice-bg-black-edit dashboard-poppins-font-style creationWidth"
                        onChange={handleModelChange}
                        value={selectedModel}
                        disabled={!selectedMake}
                      >
                        <option value="" key="select-model">
                          Select
                        </option>
                        {selectedMake &&
                          makeModelList?.[selectedMake]?.map((model, index) => (
                            <option value={model} key={index}>
                              {model}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control creationWidth"
                          placeholder="Enter Model"
                          value={customModel}
                          onChange={handleCustomModelChange}
                        />
                      </div>
                    )}
                  </td>
                </tr>

                {/* Plate No */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Plate No:
                    </label>
                  </td>
                  <td>
                    <select
                      className="select-invoice-bg-black-edit dashboard-poppins-font-style creationWidth"
                      value={selectedPlateNum}
                      onChange={handlePlateNumChange}
                    >
                      <option value="">Select</option>
                      {emiratesCode?.map((code, index) => (
                        <option key={index} value={code}>
                          {code}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>

                {/* Reg No */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Reg No:
                    </label>
                  </td>
                  <td>
                    <CustomInput
                      inputName="RegNumber"
                      inputType="RegNumber"
                      className="merchant-input-style-create-product creationWidth"
                      placeholder=""
                      editable={true}
                      onInputChange={(value: string) => {}}
                      control={control}
                    />
                  </td>
                </tr>

                {/* Chassis No */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Chassis No:
                    </label>
                  </td>
                  <td>
                    <CustomInput
                      inputName="ChassisNumber"
                      inputType="ChassisNumber"
                      className="merchant-input-style-create-product creationWidth"
                      placeholder=""
                      editable={true}
                      onInputChange={(value: string) => {}}
                      control={control}
                    />
                  </td>
                </tr>

                {/* Person Name */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Contact Person
                      <span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    <CustomInput
                      inputName="PersonName"
                      inputType="PersonName"
                      className="merchant-input-style-create-product creationWidth"
                      placeholder=""
                      editable={true}
                      onInputChange={(value: string) => {}}
                      control={control}
                      rules={rules.AuthRules.productDescription}
                    />
                  </td>
                </tr>

                {/* Mobile */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Mobile Number
                      <span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    <CustomInput
                      inputName="phoneNo"
                      inputType="text"
                      className="merchant-input-style-create-product creationWidth"
                      placeholder=""
                      editable={true}
                      onInputChange={(value: string) => {}}
                      control={control}
                      disableValidation={true}
                      // maxLength={9}
                      // rules={rules.AuthRules.phone_number}
                    />
                  </td>
                </tr>

                {/* Service Type */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Service Type<span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    <select
                      className="select-invoice-bg-black-edit dashboard-poppins-font-style creationWidth"
                      value={selectedService}
                      onChange={handleServiceTypeChange}
                      disabled={
                        !isOtherMakeSelected &&
                        (!selectedMake || !selectedModel)
                      }
                    >
                      <option value="">Select</option>
                      {serviceType?.map((type) => (
                        <option key={type.id} value={type.serviceName}>
                          {type.serviceName}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>

                {/* Location From */}
                {selectedServiceType === "DISTANCE_BASED" && (
                  <tr>
                    <td>
                      <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                        Location From
                      </label>
                    </td>
                    <td>
                      {selectedServiceType === "DISTANCE_BASED" && (
                        <div className="relative-div">
                          {selectedService === "INTERNAL MOVEMENTS" ? (
                            <div
                              className="mb-2 px-5"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <label className="px-3 align-items-center d-flex fw-normal">
                                <input
                                  type="radio"
                                  name="locationInputType"
                                  checked={locationInputType === "dropdown"}
                                  onChange={() =>
                                    setLocationInputType("dropdown")
                                  }
                                  className="mx-1"
                                />
                                Select from list
                              </label>
                              <label className="px-3 align-items-center d-flex fw-normal">
                                <input
                                  type="radio"
                                  name="locationInputType"
                                  checked={locationInputType === "search"}
                                  onChange={() =>
                                    setLocationInputType("search")
                                  }
                                  className="mx-1"
                                />
                                Search location
                              </label>
                            </div>
                          ) : null}

                          {selectedServiceType !== "DISTANCE_BASED" ||
                          selectedService === "CUSTOMER DROP" ||
                          (selectedService === "INTERNAL MOVEMENTS" &&
                            locationInputType === "dropdown") ? (
                            <select
                              className="merchant-input-style-create-product creationWidth"
                              value={selectedFromLocation}
                              onChange={(e) =>
                                handleFromLocationChange(e.target.value)
                              }
                              disabled={
                                !isOtherMakeSelected &&
                                (!selectedMake || !selectedModel)
                              }
                            >
                              <option value="" disabled>
                                Select From Location
                              </option>
                              {(selectedService === "CUSTOMER DROP" ||
                                selectedService === "INTERNAL MOVEMENTS") && (
                                <option value="Other">Other</option>
                              )}
                              {fromLocations.map((loc, index) => (
                                <option key={index} value={loc.location}>
                                  {loc.location}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <>
                              <CustomInput
                                inputName="Location"
                                inputType="Location"
                                className="merchant-input-style-create-product creationWidth"
                                placeholder="From Location"
                                editable={
                                  !!selectedServiceType &&
                                  (selectedService !== "INTERNAL MOVEMENTS" ||
                                    locationInputType === "search")
                                }
                                onInputChange={(value: string) =>
                                  handleInputChange(value)
                                }
                                control={control}
                              />
                              {addressSuggestions?.length > 0 && (
                                <div className="absolute-div">
                                  <ul
                                    className="text-start"
                                    style={{ color: "#333132" }}
                                  >
                                    {addressSuggestions.map(
                                      (suggestion, index) => (
                                        <li
                                          key={index}
                                          onClick={() =>
                                            handleSuggestionClick(suggestion)
                                          }
                                        >
                                          {suggestion}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                )}

                {/* Location To */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Location To
                    </label>
                  </td>
                  <td>
                    <div className="relative-div">
                      {selectedService === "INTERNAL MOVEMENTS" ? (
                        <div
                          className="mb-2 px-5"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <label className="px-3 align-items-center d-flex fw-normal">
                            <input
                              type="radio"
                              name="toLocationInputType"
                              checked={toLocationInputType === "dropdown"}
                              onChange={() =>
                                setToLocationInputType("dropdown")
                              }
                              className="mx-1"
                            />
                            Select from list
                          </label>
                          <label className="px-3 align-items-center d-flex fw-normal">
                            <input
                              type="radio"
                              name="toLocationInputType"
                              checked={toLocationInputType === "search"}
                              onChange={() => setToLocationInputType("search")}
                              className="mx-1"
                            />
                            Search location
                          </label>
                        </div>
                      ) : null}

                      {selectedServiceType === "DISTANCE_BASED" &&
                      selectedService !== "CUSTOMER DROP" &&
                      (selectedService !== "INTERNAL MOVEMENTS" ||
                        (selectedService === "INTERNAL MOVEMENTS" &&
                          toLocationInputType === "dropdown")) ? (
                        <div>
                          <select
                            className="merchant-input-style-create-product creationWidth"
                            value={selectedToLocation}
                            onChange={(e) =>
                              handleToLocationChange(e.target.value)
                            }
                            disabled={
                              !isOtherMakeSelected &&
                              (!selectedMake || !selectedModel)
                            }
                          >
                            <option value="" disabled>
                              Select To Location
                            </option>
                            {(selectedService === "AFL INTERNAL JOB" ||
                              selectedService === "TOWING SERVICES" ||
                              selectedService === "ACCIDENT TOWING" ||
                              selectedService === "CUSTOMER COLLECT") && (
                              <option value="Other">Other</option>
                            )}
                            {toLocations.map((loc, index) => (
                              <option key={index} value={loc.location}>
                                {loc.location}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <>
                          <CustomInput
                            inputName="RecollectionLocation"
                            inputType="RecollectionLocation"
                            className="merchant-input-style-create-product creationWidth"
                            placeholder="To Location"
                            editable={!!selectedServiceType}
                            onInputChange={(value: string) =>
                              handleRecollectionInputChange(value)
                            }
                            control={control}
                          />
                          {recollectionAddressSuggestions?.length > 0 && (
                            <div className="absolute-div">
                              <ul
                                className="text-start"
                                style={{ color: "#333132" }}
                              >
                                {recollectionAddressSuggestions?.map(
                                  (suggestion, index) => (
                                    <li
                                      key={index}
                                      onClick={() =>
                                        handleRecollectionSuggestionClick(
                                          suggestion
                                        )
                                      }
                                    >
                                      {suggestion}
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
                {/* When "Other" is selected for location, show lat/long (one field per row) */}
                {showOtherLocation && (
                  <>
                    <tr>
                      <td>
                        <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                          Other Latitude
                        </label>
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control merchant-input-style-create-product creationWidth"
                          placeholder="Latitude"
                          value={otherLatitude}
                          onChange={handleOtherLatitudeChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                          Other Longitude
                        </label>
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control merchant-input-style-create-product creationWidth"
                          placeholder="Longitude"
                          value={otherLongitude}
                          onChange={handleOtherLongitudeChange}
                        />
                      </td>
                    </tr>
                    {selectedToLocation && otherLatitude && otherLongitude && (
                      <tr>
                        <td>
                          <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                            Location Name
                          </label>
                        </td>
                        <td>
                          <textarea
                            className="form-control merchant-input-style-create-product creationWidth"
                            value={selectedToLocation}
                            readOnly
                            rows={2}
                            placeholder="Location name will appear here..."
                            style={{ resize: "none" }}
                          />
                        </td>
                      </tr>
                    )}
                  </>
                )}

                {/* Schedule Type */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Schedule Type<span className="merchantStar">*</span>
                    </label>
                  </td>
                  <td>
                    <select
                      className="merchant-input-style-create-product creationWidth"
                      value={scheduleType}
                      onChange={handleScheduleTypeChange}
                      disabled={!selectedMake || !selectedModel}
                    >
                      <option>Select</option>
                      <option value="schedule_for">Schedule For</option>
                      <option value="schedule_now">Schedule Now</option>
                    </select>
                    {scheduleType === "schedule_for" && (
                      <div className="mt-3">
                        <label className="form-label dashboard-poppins-font-style creationWidth">
                          Schedule For<span className="merchantStar">*</span>
                        </label>
                        <div className="input-date-container">
                          <input
                            type="datetime-local"
                            id="datetime"
                            value={dateTime}
                            onChange={handleDateTimeChange}
                            min={minDateTime}
                            className={`merchant-input-style-create-product creationWidth ${
                              timeError ? "is-invalid" : ""
                            }`}
                          />
                          {timeError && (
                            <div className="text-danger small mt-1">
                              {timeError}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </td>
                </tr>

                {/* Comments */}
                <tr>
                  <td>
                    <label className="form-label dashboard-poppins-font-style fontSizeCreation creationWidth">
                      Comments
                    </label>
                  </td>
                  <td>
                    <textarea
                      name="comments"
                      id="comments"
                      rows={5}
                      value={comments}
                      onChange={handleCommentsChange}
                      className="select-invoice-bg-black-textarea creationWidth"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="col-12 pt-4 pb-3 text-end">
              <button
                className="invoice-approve-btn px-4"
                disabled={isButtonDisabled() || isSubmitting}
                onClick={handleUpdate}
              >
                + <img src={dashboard_invoice_approve} height={"14px"} alt="" />
                &nbsp;Create Request
              </button>
            </div>
          </div>
        </div>
      </div>
      <AFLSuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          navigate("/dashboard/servicelist");
          setShowSuccessModal(false);
        }}
        message="Created Successfully"
        refNumber={RefNumber}
      />
      <AFLErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message={errorMessage}
      />
    </div>
  );
};

export default ServiceCreation;
